export default "__VITE_ASSET__cf78d70c__"